import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";

import Home from "@/pages/Home";
import ShopAll from "@/pages/ShopAll";
import PopcornShop from "@/pages/PopcornShop";
import CookieShop from "@/pages/CookieShop";
import PecansPage from "@/pages/PecansPage";
import CartPage from "@/pages/CartPage";
import Checkout from "@/pages/Checkout";
import Payment from "@/pages/Payment";
import Confirmation from "@/pages/Confirmation";
import TrackOrder from "@/pages/TrackOrder";
import About from "@/pages/About";

import AdminLogin from "@/pages/admin/AdminLogin";
import Dashboard from "@/pages/admin/Dashboard";
import Orders from "@/pages/admin/Orders";
import Products from "@/pages/admin/Products";
import DeliverySettings from "@/pages/admin/DeliverySettings";
import Promos from "@/pages/admin/Promos";
import Analytics from "@/pages/admin/Analytics";
import StoreSettings from "@/pages/admin/StoreSettings";

const store = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={store(<Home />)} />
              <Route path="/shop" element={store(<ShopAll />)} />
              <Route path="/popcorn" element={store(<PopcornShop />)} />
              <Route path="/cookies" element={store(<CookieShop />)} />
              <Route path="/cinnamon-pecans" element={store(<PecansPage />)} />
              <Route path="/cart" element={store(<CartPage />)} />
              <Route path="/checkout" element={store(<Checkout />)} />
              <Route path="/payment/:order_number" element={store(<Payment />)} />
              <Route path="/confirmation/:order_number" element={store(<Confirmation />)} />
              <Route path="/track" element={store(<TrackOrder />)} />
              <Route path="/about" element={store(<About />)} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Dashboard />} />
              <Route path="/admin/orders" element={<Orders />} />
              <Route path="/admin/products" element={<Products />} />
              <Route path="/admin/delivery" element={<DeliverySettings />} />
              <Route path="/admin/promos" element={<Promos />} />
              <Route path="/admin/analytics" element={<Analytics />} />
              <Route path="/admin/settings" element={<StoreSettings />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
